/**
 * Environment Configuration
 * Validates and exports environment variables
 */

interface EnvConfig {
  API_URL: string
  PUBLIC_SITE_URL: string
  IS_DEV: boolean
  IS_PROD: boolean
  /** eBay integration is visible & connectable. On by default; set VITE_EBAY_ENABLED=false to hide it. */
  EBAY_ENABLED: boolean
}

/**
 * Validates required environment variables
 * @throws Error if required variables are missing
 */
function validateEnv(): EnvConfig {
  const isDev = import.meta.env.DEV
  const isProd = import.meta.env.PROD

  // In development, default to Vite proxy on /api.
  // In production, default to relative /api (Nginx handles proxying).
  // Allow override via VITE_API_URL in both environments.
  const apiUrl = (import.meta.env.VITE_API_URL || '/api')
  const publicSiteUrl = (import.meta.env.VITE_PUBLIC_SITE_URL || '/').trim() || '/'

  // eBay is enabled by default; set VITE_EBAY_ENABLED=false to explicitly hide it
  const ebayEnabled = import.meta.env.VITE_EBAY_ENABLED !== 'false'

  return {
    API_URL: apiUrl,
    PUBLIC_SITE_URL: publicSiteUrl,
    IS_DEV: isDev,
    IS_PROD: isProd,
    EBAY_ENABLED: ebayEnabled,
  }
}

// Validate on module load
export const env = validateEnv()

// Log configuration in development
if (env.IS_DEV) {
  console.log('🔧 Environment Configuration:', {
    API_URL: env.API_URL || '(using Vite proxy)',
    PUBLIC_SITE_URL: env.PUBLIC_SITE_URL,
    IS_DEV: env.IS_DEV,
    IS_PROD: env.IS_PROD
  })
}

export default env
